import { EntityCollection } from "models/list-user-entity-collection";
import { ListEntityField } from "models/list-entity-field";
import { Locale } from "models/locale";
import { parse } from "./locale";

export const parseUserValues = (
  field: ListEntityField,
  collections: EntityCollection[],
  locale: Locale,
) => {
  const { uuid, datatype } = field;

  // get values
  const rawValues: string[] = [];
  collections.forEach((collection) => {
    const { entityCollectionValues = [] } = collection;
    const filtered = entityCollectionValues.filter(
      (v) => v.list_entity_field_uuid === uuid,
    );
    filtered.forEach((ecvalue) => {
      const { data = { value: "" } } = ecvalue;
      const { value = "" } = data;
      rawValues.push(String(value));
    });
  });

  const formattedValues: string[] = [];
  // decide formatting
  switch (datatype) {
    case "text":
    case "textarea":
    case "email":
    case "phone":
    case "ssn":
      rawValues.forEach((v) => formattedValues.push(v));
      break;
    case "dropdown":
      const { options = [] } = field;
      rawValues.forEach((v) => {
        const option = (options || []).find((o) => o.value === v);
        if (option) {
          formattedValues.push(parse(option.text, locale));
        }
      });
      break;
    case "check":
      rawValues.forEach((v) =>
        formattedValues.push(v === "yes" ? "Kyllä" : "Ei"),
      );
      break;
    default:
      formattedValues.push("TODO");
      break;
  }

  return formattedValues;
};
